import React from "react";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import InstructorGrid from "../components/InstructorGrid";
import '../components/adminDashboard.css';

function InstructorDashboard() {
    return (
        <div style={{background: 'white'}}>
            <NavBar page="instructor"/>
            <InstructorGrid/>
            <Footer/>
        </div>
    )
}

export default InstructorDashboard;